import { render, staticRenderFns } from "./box9.vue?vue&type=template&id=94d1a0f0&scoped=true&"
import script from "./box9.vue?vue&type=script&lang=js&"
export * from "./box9.vue?vue&type=script&lang=js&"
import style0 from "./box9.vue?vue&type=style&index=0&id=94d1a0f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d1a0f0",
  null
  
)

export default component.exports